import { useEffect, useState } from 'react';

import moment from 'moment';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

import { FormatDisplay } from '../../../shared/format';
import { ToastService } from '../../../AppToast';

import { StoreService } from '../cua-hang-xang-dau/StoreService';
import { DeviceService } from '../thiet-bi/DeviceService';
import { PetrolimexService } from '../hang-hoa-xang-dau/PetrolimexService';
import { PetrolimexLogService } from './PetrolimexLogService';
import { useCalendarFooterTemplate } from '../../../shared/hooks/Form';

export const ExportExcel = ({ display, setDisplay }) => {

  const [submitting, setSubmitting] = useState(false);

  const [reportType, setReportType] = useState(null);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [storeCode, setStoreCode] = useState(null);
  const [storeCodeOptions, setStoreCodeOptions] = useState([]);
  const [deviceCode, setDeviceCode] = useState(null);
  const [deviceCodeOptions, setDeviceCodeOptions] = useState([]);
  const [productCode, setProductCode] = useState(null);
  const [productCodeOptions, setProductCodeOptions] = useState([]);
  const [staffCode, setStaffCode] = useState('');
  const [quantityOpr, setQuantityOpr] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [priceOpr, setPriceOpr] = useState(null);
  const [price, setPrice] = useState(null);
  const [totalAmountOpr, setTotalAmountOpr] = useState(null);
  const [isPaymented, setIsPaymented] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [status, setStatus] = useState(null);

  const { render: footerFromDate } = useCalendarFooterTemplate({ applyCallback: setFromDate });
  const { render: footerToDate } = useCalendarFooterTemplate({ applyCallback: setToDate });

  useEffect(() => {
    if (display) {
      setReportType(reportTypes[0].value);
      setFromDate(moment().startOf('day').toDate());
      setToDate(moment().endOf('day').toDate());
      setStoreCode(null);
      setDeviceCode(null);
      setDeviceCodeOptions([]);
      setProductCode(null);
      setStaffCode('');
      setQuantityOpr(null);
      setQuantity(null);
      setPriceOpr(null);
      setPrice(null);
      setTotalAmountOpr(null);
      setTotalAmount(null);
      setStatus(null);

      if (!storeCodeOptions?.length) {
        initData();
      }
    }
  }, [display]);

  useEffect(() => {
    if (!fromDate) {
      setFromDate(moment().startOf('day').toDate());
    }
  }, [fromDate]);
  useEffect(() => {
    if (!toDate) {
      setToDate(moment().endOf('day').toDate());
    }
  }, [toDate]);

  const initData = () => {
    StoreService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setStoreCodeOptions(items.map(item => {
        item.storeNameDisplay = `${item.code} - ${item.storeName}`
        return { ...item };
      }));
    });
    PetrolimexService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setProductCodeOptions(items.map(item => {
        return { value: item.code, label: item.code };
      }));
    });
  }

  useEffect(() => {
    if (storeCode?.length) {
      const loadDevices = async () => {
        const _deviceCodeOptions = [];
        for (const storeCodeItem of storeCode) {
          await DeviceService.getList({ maxResultCount: 1000, storeCode: storeCodeItem.code }).then(({ items }) => {
            for (const item of items) {
              _deviceCodeOptions.push({ value: item.code, label: `${item.code} [Cửa hàng ${storeCodeItem.storeName}]` });
            }
          });
        }
        setDeviceCodeOptions(_deviceCodeOptions);
      }
      loadDevices();
    } else {
      setDeviceCodeOptions([]);
    }
  }, [storeCode]);

  const download = () => {
    if (!submitting) {

      const params = {
        take: 500,
        sorting: 'saleDate',
        sortType: 'DESCEND',
        condition: []
      };
      if (fromDate && toDate) {
        if (fromDate > toDate) {
          return ToastService.error('Điều kiện Từ ngày phải nhỏ hơn hoặc bằng Đến ngày');
        }
        params.condition.push({
          propertyName: 'saleDate',
          operation: '>=',
          value: FormatDisplay.date(fromDate, 'YYYY-MM-DDTHH:mm:ss')
        });
        params.condition.push({
          condition: 'And',
          propertyName: 'saleDate',
          operation: '<=',
          value: FormatDisplay.date(toDate, 'YYYY-MM-DDTHH:mm:ss')
        });
      } else {
        return ToastService.error('Trường từ ngày - đến ngày không được để trống.');
      }

      if (storeCode?.length) {
        params.condition.push({
          propertyName: 'storeCode',
          operation: 'LIKEArray',
          value: storeCode.map(it => it.code).join(',')
        });
      }
      if (deviceCode?.length) {
        params.condition.push({
          propertyName: 'deviceCode',
          operation: 'LIKEArray',
          value: deviceCode.join(',')
        });
      }
      if (productCode?.length) {
        params.condition.push({
          propertyName: 'productCode',
          operation: 'LIKEArray',
          value: productCode.join(',')
        });
      }
      if (staffCode?.trim()) {
        params.condition.push({
          propertyName: 'staffCode',
          operation: '=',
          value: staffCode
        });
      }
      if (typeof quantity === 'number') {
        if (!quantityOpr) {
          return ToastService.error('Toán tử Số lượng không được để trống.');
        }
        params.condition.push({
          propertyName: 'quantity',
          operation: quantityOpr,
          value: quantity
        });
      }
      if (typeof price === 'number') {
        if (!priceOpr) {
          return ToastService.error('Toán tử Đơn giá không được để trống.');
        }
        params.condition.push({
          propertyName: 'price',
          operation: priceOpr,
          value: price
        });
      }
      if (typeof totalAmount === 'number') {
        if (!totalAmountOpr) {
          return ToastService.error('Toán tử Tổng tiền không được để trống.');
        }
        params.condition.push({
          propertyName: 'totalAmount',
          operation: totalAmountOpr,
          value: totalAmount
        });
      }
      if (status?.length < 4) {
        if (status.includes('null')) {
          if (status?.length === 1) {
            params.condition.push({
              propertyName: 'status',
              operation: 'NotHasValue',
              value: status.join(',')
            });
          } else {
            return ToastService.error('Điều kiện tìm Trạng thái tạo hóa đơn không hợp lệ.');
          }
        } else {
          params.condition.push({
            propertyName: 'status',
            operation: 'LIKEArray',
            value: status.join(',')
          });
        }
      }
      if (typeof isPaymented === 'boolean') {
        params.condition.push({
          propertyName: 'isPaymented',
          operation: '=',
          value: isPaymented
        });
      }

      setSubmitting(true);

      PetrolimexLogService.downloadReportExcel(reportType, params).then(data => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `bao-cao-${reportType === 'detail' ? 'chi-tiet' : 'tong-hop'}-giao-dich-xang-dau.xlsx`;
        link.click();
      }).finally(() => {
        setSubmitting(false);
      });

    }
  }

  const footer = (
    <div>
      <Button label="Đóng" onClick={() => setDisplay(null)} className="p-button-outlined p-button-secondary p-button-sm" />
      <Button label="Kết xuất Excel" onClick={download} loading={submitting} className="p-button-outlined p-button-sm" />
    </div>
  );

  return (
    <Dialog header={`Kết xuất báo cáo ${reportType === 'detail' ? 'chi tiết' : 'tổng hợp'} giao dịch xăng dầu`} footer={footer} visible={!!display} style={{ width: '60rem' }} position="top" onHide={() => setDisplay(null)}>
      <div className="p-fluid formgrid grid mt-2">

        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="reportType" className="col-3">Loại báo cáo</label>
            <div className="col-9">
              <Dropdown id="reportType" value={reportType} onChange={e => setReportType(e.value)} options={reportTypes} />
            </div>
          </div>
        </div>

        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="fromDate" className="col-3">Từ ngày<span className="required">*</span></label>
            <div className="col-9">
              <Calendar value={fromDate} onChange={e => setFromDate(e.value)} dateFormat="dd/mm/yy" showTime={true} showSeconds={true} footerTemplate={footerFromDate} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="toDate" className="col-3">Đến ngày<span className="required">*</span></label>
            <div className="col-9">
              <Calendar value={toDate} onChange={e => setToDate(e.value)} dateFormat="dd/mm/yy" showTime={true} showSeconds={true} footerTemplate={footerToDate} />
            </div>
          </div>
        </div>

        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="storeCode" className="col-3">Cửa hàng</label>
            <div className="col-9">
              <MultiSelect value={storeCode} onChange={e => setStoreCode(e.value)} options={storeCodeOptions} optionLabel="storeNameDisplay" />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="deviceCode" className="col-3">Vòi bơm</label>
            <div className="col-9">
              <MultiSelect value={deviceCode} onChange={e => setDeviceCode(e.value)} options={deviceCodeOptions} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="productCode" className="col-3">Mã hàng</label>
            <div className="col-9">
              <MultiSelect value={productCode} onChange={e => setProductCode(e.value)} options={productCodeOptions} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="staffCode" className="col-3">Mã nhân viên</label>
            <div className="col-9">
              <InputText id="staffCode" value={staffCode} onChange={e => setStaffCode(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="quantityOpr" className="col-3">Số lượng</label>
            <div className="col-2">
              <Dropdown id="quantityOpr" value={quantityOpr} onChange={e => setQuantityOpr(e.value)} options={operations} />
            </div>
            <div className="col-7">
              <InputNumber locale={FormatDisplay.locales} value={quantity} onValueChange={e => setQuantity(e.value)} maxFractionDigits={6} max={1E15} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="priceOpr" className="col-3">Đơn giá</label>
            <div className="col-2">
              <Dropdown id="priceOpr" value={priceOpr} onChange={e => setPriceOpr(e.value)} options={operations} />
            </div>
            <div className="col-7">
              <InputNumber locale={FormatDisplay.locales} value={price} onValueChange={e => setPrice(e.value)} maxFractionDigits={6} max={1E15} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="totalAmountOpr" className="col-3">Tổng tiền</label>
            <div className="col-2">
              <Dropdown id="totalAmountOpr" value={totalAmountOpr} onChange={e => setTotalAmountOpr(e.value)} options={operations} />
            </div>
            <div className="col-7">
              <InputNumber locale={FormatDisplay.locales} value={totalAmount} onValueChange={e => setTotalAmount(e.value)} maxFractionDigits={6} max={1E15} />
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="isPaymented" className="col-3">Trạng thái thanh toán</label>
            <div className="col-9">
              <Dropdown id="isPaymented" value={isPaymented} onChange={e => setIsPaymented(e.value)} options={isPaymentedStatus} />
            </div>
            <div className="col-7">
            </div>
          </div>
        </div>
        <div className="col-12 md:col-12">
          <div className="field grid">
            <label htmlFor="status" className="col-3">Trạng thái tạo hóa đơn</label>
            <div className="col-9">
              <MultiSelect value={status} onChange={e => setStatus(e.value)} options={createInvoiceStatuses} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

const reportTypes = [
  { value: 'detail', label: 'Báo cáo chi tiết giao dịch' },
  { value: 'sumary', label: 'Báo cáo tổng hợp giao dịch' }
];

const operations = [
  { value: '>', label: '>' },
  { value: '>=', label: '>=' },
  { value: '<', label: '<' },
  { value: '<=', label: '<=' },
  { value: '=', label: '=' }
];

const createInvoiceStatuses = [
  { value: 'null', label: 'Chưa tạo' },
  { value: '1', label: 'Đã tạo' },
  { value: '2', label: 'Tạo lỗi' },
  { value: '3', label: 'Bị hủy' }
];

const isPaymentedStatus = [
  { value: false, label: 'Chưa thanh toán' },
  { value: true, label: 'Đã thanh toán' },
];